/**
 * Habilleur "Maak de look af"
 * Server-side catalogus is leidend — JS bindt alleen interactie (maat kiezen, add-to-cart).
 */

function bindWearItWithSizePickers(list) {
  list.querySelectorAll('.habilleur-wiw__size-details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      list.querySelectorAll('.habilleur-wiw__size-details[open]').forEach((other) => {
        if (other !== details) other.open = false;
      });
    });
  });

  list.querySelectorAll('.habilleur-wiw__size-option').forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (button.disabled || button.dataset.available === 'false') return;

      const variantId = button.dataset.variantId;
      const details = button.closest('.habilleur-wiw__size-details');
      const originalText = button.textContent;

      button.disabled = true;
      button.textContent = 'Bezig…';

      try {
        const res = await fetch(
          window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
          }
        );

        if (!res.ok) {
          button.textContent = originalText;
          button.disabled = false;
          return;
        }

        button.textContent = 'Toegevoegd';
        if (details) details.open = false;
        document.dispatchEvent(new CustomEvent('cart:update'));

        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      } catch {
        button.textContent = originalText;
        button.disabled = false;
      }
    });
  });
}

function bindWearItWithForms(list) {
  list.querySelectorAll('.habilleur-wiw__form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (button?.disabled) return;

      const formData = new FormData(form);
      button.disabled = true;
      button.textContent = 'Bezig…';

      try {
        const res = await fetch(
          window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js',
          { method: 'POST', headers: { Accept: 'application/json' }, body: formData }
        );

        if (res.ok) {
          button.textContent = 'Toegevoegd';
          document.dispatchEvent(new CustomEvent('cart:update'));
        } else {
          button.textContent = 'Opnieuw';
          button.disabled = false;
        }
      } catch {
        button.textContent = 'Voeg toe aan winkelwagentje';
        button.disabled = false;
      }
    });
  });
}

function bindWearItWithInteractions(list) {
  bindWearItWithForms(list);
  bindWearItWithSizePickers(list);
}

function initWearItWith() {
  document.querySelectorAll('habilleur-wear-it-with').forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    const list = root.querySelector('[ref="list"]') || root.querySelector('.habilleur-wiw__list');
    const empty = root.querySelector('.habilleur-wiw__empty');
    if (!list) return;

    const rows = [...list.querySelectorAll(':scope > .habilleur-wiw__row')];

    if (rows.length > 0) {
      if (empty) empty.hidden = true;
      bindWearItWithInteractions(list);
    } else if (empty) {
      empty.hidden = false;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWearItWith);
} else {
  initWearItWith();
}

document.addEventListener('shopify:section:load', initWearItWith);
